import React, { useState, useEffect, useCallback } from "react";
import "./../../App.css";
import "./Transactions.css";
import {
  CreateButton,
  CreateSearchBarWithPlaceHolder,
} from "./../CommonObjects";
import axios from "axios";
import { token, domain } from "./../Security";
import { CreateTableForEmployeeSelect } from "./../ManageTable";
import loadingSpinner from "./../../assets/loading.gif";
import { useTable } from "react-table";
import { globalTimeFormat } from "./../Security";
// icons
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import UploadIcon from "@mui/icons-material/Upload";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

function Leave({ user, userAccess, isHideSideMenu }) {
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [employee, setEmployee] = useState(
    user.employeePersonalInformationFullName
  );
  const [employeeId, setEmployeeId] = useState(
    user.employeePersonalInformationId
  );
  const [leaveTypeId, setLeaveTypeId] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [days, setDays] = useState("");
  const [temp_days, setTemp_days] = useState("");
  const [isHalfDay, setIsHalfDay] = useState(false);
  const [reason, setReason] = useState("");
  const [remainingLeaves, setRemainingLeaves] = useState([]);
  const [files, setFiles] = useState([]);

  const [viewedData, setViewedData] = useState([]);

  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [showVieHistoryForm, setShowVieHistoryForm] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div
          className={`modal-overlay toggleMessage-overlay ${
            form ? "open" : ""
          }`}
        >
          {form && (
            <div
              className="modal toggleMessage"
              style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}
            >
              <div className="column">
                {isSuccess ? (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      alignItems: "center",
                    }}
                  >
                    <CheckCircleIcon />
                    <span>{"SUCCESS MESSAGE"}</span>
                  </div>
                ) : (
                  <div
                    className="request_title row"
                    style={{
                      fontWeight: "bold",
                      color: "#DD5746",
                      alignItems: "center",
                    }}
                  >
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                )}
                <span
                  style={{
                    textAlign: "center",
                    padding: "10px 0",
                    color: isSuccess ? "green" : "#DD5746",
                  }}
                >
                  {message}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const leaveUrl = domain + "/api/LeaveRequest";

  const fetchLeaveBalanceData = useCallback(async () => {
    setLoadingRequest(true);
    const url = domain + `/api/Employee/${employeeId}`;
    await axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setViewedData(response.data);
        setRemainingLeaves(response.data.employeeLeave); // Set the response data to the state
      })
      .catch((error) => {
        setLoadingRequest(false);
        console.error("Error fetching data:", error);
      });

    setLoadingRequest(false);
  }, [employeeId]);
  const fetchLeaveTypes = useCallback(async () => {
    const url = domain + "/api/LeaveType";

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (employeeId) {
      fetchLeaveBalanceData();
    }
  }, [employeeId, fetchLeaveBalanceData]);

  const updateLeaveBalance = async (leaveType) => {
    const apiUrlEmployee = domain + "/api/Employee";

    const data = {
      id: viewedData.id,
      employeeId: viewedData.employeeId,
      lastName: viewedData.lastName,
      firstName: viewedData.firstName,
      middleName: viewedData.middleName,
      extensionName: viewedData.extensionName,
      fullName: viewedData.fullName,
      nickName: viewedData.nickName,
      age: viewedData.age,
      dateOfBirth: viewedData.dateOfBirth,
      placeOfBirth: viewedData.placeOfBirth,
      civilStatus: viewedData.civilStatus,
      bloodType: viewedData.bloodType,
      height: viewedData.height,
      weight: viewedData.weight,
      citizenship: viewedData.citizenship,
      religion: viewedData.religion,
      gender: viewedData.gender,
      mobileNumber: viewedData.mobileNumber,
      emailAddress: viewedData.emailAddress,
      blkLot: viewedData.blkLot,
      street: viewedData.street,
      barangay: viewedData.barangay,
      city: viewedData.city,
      postalCode: viewedData.postalCode,
      yearsOfStay: viewedData.yearsOfStay,
      photo: viewedData.photo,
      deviceNumber: viewedData.deviceNumber,
      employeeInformation: viewedData.employeeInformation,
      employeeReportTo: viewedData.employeeReportTo,
      employeeAccountInformation: viewedData.employeeAccountInformation,
      employeeEducationAttainments: viewedData.employeeEducationAttainments,
      employeeDependents: viewedData.employeeDependents,
      employeeFamilyData: viewedData.employeeFamilyData,
      employeeEmergencyContacts: viewedData.employeeEmergencyContacts,
      employeeLeave: viewedData.employeeLeave
        ? {
            employeePersonalInformationId: viewedData.id,
            totalVacation: viewedData.employeeLeave?.totalVacation ?? 0,
            totalSick: viewedData.employeeLeave?.totalSick ?? 0,
            totalServiceIncentive:
              viewedData.employeeLeave?.totalServiceIncentive ?? 0,
            totalSoloParent: viewedData.employeeLeave?.totalSoloParent ?? 0,
            vacationRemaining:
              leaveType === "Vacation Leave" &&
              viewedData.employeeLeave.vacationRemaining
                ? viewedData.employeeLeave.vacationRemaining -
                  (isHalfDay ? 0.5 : days)
                : viewedData.employeeLeave.vacationRemaining,
            sickRemaining:
              leaveType === "Sick Leave" &&
              viewedData.employeeLeave.sickRemaining
                ? viewedData.employeeLeave.sickRemaining -
                  (isHalfDay ? 0.5 : days)
                : viewedData.employeeLeave.sickRemaining,
            serviceIncentiveRemaining:
              leaveType === "Service Incentive Leave" &&
              viewedData.employeeLeave.serviceIncentiveRemaining
                ? viewedData.employeeLeave.serviceIncentiveRemaining -
                  (isHalfDay ? 0.5 : days)
                : viewedData.employeeLeave.serviceIncentiveRemaining,
            soloParentRemaining:
              leaveType === "Solo Parent Leave" &&
              viewedData.employeeLeave.soloParentRemaining
                ? viewedData.employeeLeave.soloParentRemaining -
                  (isHalfDay ? 0.5 : days)
                : viewedData.employeeLeave.soloParentRemaining,
          }
        : viewedData.employeeLeave,
      employeeStatuses: viewedData.employeeStatuses,
    };

    console.log("Final bulkData:", JSON.stringify(data, null, 2));

    try {
      await axios.put(apiUrlEmployee + `/${viewedData.id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Data updated successfully");
    } catch (error) {
      console.error("There was a problem updating data:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (parseInt(leaveTypeId) === 2) {
      if (remainingLeaves.vacationRemaining < days) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Not enough vacation leave.");
        return;
      }
    } else if (parseInt(leaveTypeId) === 1) {
      if (remainingLeaves.sickRemaining < days) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Not enough sick leave.");
        return;
      }
    } else if (parseInt(leaveTypeId) === 5) {
      if (remainingLeaves.serviceIncentiveRemaining < days) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Not enough service incentive leave.");
        return;
      }
    } else if (parseInt(leaveTypeId) === 8) {
      if (remainingLeaves.soloParentRemaining < days) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Not enough solo parent leave.");
        return;
      }
    }

    const getFormattedDate = () => {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}T00:00`;
      return formattedDate;
    };

    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    let base64String = "";
    let photoToBeSave = "";

    if (files.length > 0) {
      base64String = await toBase64(files[0]);
      photoToBeSave = base64String.split(",")[1];
    }

    const uploadImage = files ? photoToBeSave : null;

    const data = {
      employeePersonalInformationId: employeeId,
      approverId: null,
      requestTypeId: 1, // 1 is Leave Request
      reason: reason,
      reasonForRejection: null,
      status: "Sent",
      dateRequested: getFormattedDate(),
      dateCompleted: getFormattedDate(),
      content: uploadImage,
      dateFrom: dateFrom,
      dateTo: dateTo,
      days: isHalfDay ? "0.5" : days,
      leaveTypeId: leaveTypeId,
      isHalfDay: isHalfDay,
    };

    console.log('Final bulkData:', JSON.stringify(data, null, 2));

    try {
      setLoadingRequest(true);
      const response = await axios.post(leaveUrl, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      // Reload table data and reset form fields

      const leaveTypesData = await fetchLeaveTypes();
      const _leaveType = leaveTypesData.find(
        (leave) => leave.id.toString() === leaveTypeId.toString()
      );
      await updateLeaveBalance(_leaveType.description);
      await fetchLeaveBalanceData();

      await sendSms(response.data);
      await sendEmail(response.data);
      await createApproval(response.data);

      setLeaveTypeId("");
      setDateFrom("");
      setDateTo("");
      setDays("");
      setIsHalfDay(false);
      setReason("");
      setFiles("");

      setShowRequestMessage(true);
      setIsSuccess(true);
      console.log("Data added successfully");
    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error("Error:", error);
      const errorMessage = JSON.parse(
        error.response.request.responseText
      ).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  };
  const createApproval = async (dataToAdd) => {
    const apiUrl = domain + "/api/Approval";

    const data = {
      requestId: dataToAdd.id,
      requestTypeId: dataToAdd.requestTypeId,
      primaryApproverId: null,
      primaryApproverUpdateDate: null,
      primaryApproverStatus: "Pending",
      secondaryApproverId: null,
      secondaryApproverUpdateDate: null,
      secondaryApproverStatus: "Pending",
      tertiaryApproverId: null,
      tertiaryApproverUpdateDate: null,
      tertiaryApproverStatus: "Pending",
    };

    try {
      await axios.post(apiUrl + `/${0}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("create approval success");
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  };
  const handleFileUpload = () => {
    setShowRequestMessage(true);
    setIsSuccess(false);
    setRequestMessage("This is undermaintenance");
  };

  const [errorState, setErrorState] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const openWarningForm = () => {
    setShowWarning(true);
  };
  const closeWarningForm = () => {
    setShowWarning(false);
  };

  const submit = (e) => {
    if (!employee || !leaveTypeId || !dateFrom || !dateTo || !days) {
      setErrorState(true);
      return;
    }

    if (days !== temp_days) {
      openWarningForm();
      return;
    }

    handleSubmit(e);
    setErrorState(false);
  };

  const openViewHistoryForm = () => {
    setShowVieHistoryForm(true);
  };
  const closeViewHistoryForm = () => {
    setShowVieHistoryForm(false);
  };

  // for upload
  const handleBrowse = async (e) => {
    const fileList = Array.from(e.target.files);

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }

      const compressed = await compressImage(fileList[0]);
      setFiles([compressed]);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    e.currentTarget.style.backgroundColor = "white";

    if (fileList.length > 0) {
      if (!fileList[0].type.startsWith("image/")) {
        alert("Please select an image file.");
        setFiles("");
        return;
      }

      const compressed = await compressImage(fileList[0]);
      setFiles([compressed]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };

  const clearFiles = () => {
    setFiles([]);
    document.getElementById("fileInput").value = "";
  };

  // 🔽 Utility: compress image to ~100KB
  const compressImage = (file, maxSizeKB = 100) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          // scale down to smaller size (e.g. half)
          const scale = Math.sqrt(maxSizeKB * 1024 / file.size);
          const width = img.width * scale;
          const height = img.height * scale;

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          let quality = 0.9;
          let dataUrl = canvas.toDataURL("image/jpeg", quality);

          // Loop: reduce quality until under target size
          while (dataUrl.length / 1024 > maxSizeKB && quality > 0.1) {
            quality -= 0.05;
            dataUrl = canvas.toDataURL("image/jpeg", quality);
          }

          // Convert back to File
          fetch(dataUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const newFile = new File([blob], file.name, { type: "image/jpeg" });
              resolve(newFile);
            });
        };
      };
    });
  };

  //send sms
  const fetchDataApproverById = useCallback(async () => {
    const apiUrl = domain + "/api/ApproverHierarchy";

    try {
      const response = await axios.get(
        apiUrl + `/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [user]);
  const fetchDataEmployeesById = useCallback(async (id) => {
    const apiUrl = domain + "/api/Employee";

    try {
      const response = await axios.get(apiUrl + `/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, []);
  const getApproverContact = async () => {
    const formatPhoneNumber = (number) => {
      // Remove all dashes
      const cleanedNumber = number.replace(/-/g, "");

      // Check if the number starts with '0' and remove it
      const formattedNumber = cleanedNumber.startsWith("0")
        ? "+63" + cleanedNumber.slice(1)
        : "+63" + cleanedNumber;

      return formattedNumber;
    };

    const myApprover = await fetchDataApproverById();
    // const employeesInfo = await fetchDataEmployeesById();
    let approverNumbers = [];

    if (myApprover.primaryApprover) {
      if (myApprover.primaryApprover.primaryApprover1Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover1Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover1Id,
            fullName: myApprover.primaryApprover.primaryApprover1FullName,
          });
        }
      }

      if (myApprover.primaryApprover.primaryApprover2Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover2Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover2Id,
            fullName: myApprover.primaryApprover.primaryApprover2FullName,
          });
        }
      }

      if (myApprover.primaryApprover.primaryApprover3Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover3Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover3Id,
            fullName: myApprover.primaryApprover.primaryApprover3FullName,
          });
        }
      }

      if (myApprover.primaryApprover.primaryApprover4Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.primaryApprover.primaryApprover4Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.primaryApprover.primaryApprover4Id,
            fullName: myApprover.primaryApprover.primaryApprover4FullName,
          });
        }
      }
    }

    if (myApprover.secondaryApprover) {
      if (myApprover.secondaryApprover.secondaryApprover1Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover1Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover1Id,
            fullName: myApprover.secondaryApprover.secondaryApprover1FullName,
          });
        }
      }

      if (myApprover.secondaryApprover.secondaryApprover2Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover2Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover2Id,
            fullName: myApprover.secondaryApprover.secondaryApprover2FullName,
          });
        }
      }

      if (myApprover.secondaryApprover.secondaryApprover3Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover3Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover3Id,
            fullName: myApprover.secondaryApprover.secondaryApprover3FullName,
          });
        }
      }

      if (myApprover.secondaryApprover.secondaryApprover4Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.secondaryApprover.secondaryApprover4Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.secondaryApprover.secondaryApprover4Id,
            fullName: myApprover.secondaryApprover.secondaryApprover4FullName,
          });
        }
      }
    }

    if (myApprover.tertiaryApprover) {
      if (myApprover.tertiaryApprover.tertiaryApprover1Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover1Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover1Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover1FullName,
          });
        }
      }

      if (myApprover.tertiaryApprover.tertiaryApprover2Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover2Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover2Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover2FullName,
          });
        }
      }

      if (myApprover.tertiaryApprover.tertiaryApprover3Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover3Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover3Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover3FullName,
          });
        }
      }

      if (myApprover.tertiaryApprover.tertiaryApprover4Id) {
        const foundndInfo = await fetchDataEmployeesById(
          myApprover.tertiaryApprover.tertiaryApprover4Id
        );

        if (foundndInfo && foundndInfo.mobileNumber) {
          approverNumbers.push({
            phoneNumber: formatPhoneNumber(foundndInfo.mobileNumber),
            id: myApprover.tertiaryApprover.tertiaryApprover4Id,
            fullName: myApprover.tertiaryApprover.tertiaryApprover4FullName,
          });
        }
      }
    }

    return approverNumbers;
  };
  const sendSms = async (data) => {
    const formattedNumber = data.referenceNumber.toString().padStart(6, "0");
    const contacts = await getApproverContact();

    if (contacts.length <= 0) {
      return;
    }

    const composeMessage = `Hello,

${employee} filed an Leave Request. 

Please check reference number LV-${formattedNumber} in the portal.`;
    for (const contact of contacts) {
      const smsData = {
        requestTypeId: 1,
        date: new Date(),
        senderId: user.employeePersonalInformationId,
        senderFullName: user.employeePersonalInformationFullName,
        message: composeMessage,
        recipientId: contact.id,
        recipientFullName: contact.fullName,
        recipientMobileNumber: contact.phoneNumber, // phoneNumber
      };

      try {
        const response = await axios.post(
          "http://161.49.93.114:8081/api/Sms/send-sms",
          smsData
        ); // euro asia
        // const response = await axios.post('http://192.168.10.157:8082/api/Sms/send-sms', smsData); // my server
        console.log(
          response,
          `SMS request sent to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
        );
      } catch (error) {
        console.error(
          `Error sending SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}:`,
          error
        );
        console.log(
          `Failed to send SMS request to ${smsData.recipientFullName} ${smsData.recipientMobileNumber}.`
        );
      }
    }
  };
  const sendEmail = async (data) => {
        const formattedNumber = data.referenceNumber.toString().padStart(6, "0");

        const createEmailData = (approvers) => { 
        return (
            approvers
                ?.filter(approver => { 
                return approver.email
                })
                .map(approver => {
                return ({
                    to: approver.email,
                    subject: `LV-${formattedNumber} - ${data?.employeePersonalInformationFullName || "UNKNOWN"}`,
                    body: `Hello, ${data?.employeePersonalInformationFullName || "UNKNOWN"} filed an Leave Request. Please check reference number LV-${formattedNumber} in the portal.`
                })}) || []
        )};

        const _primaryData = createEmailData(data?.approver?.primaryApprovers);
        const _secondaryData = createEmailData(data?.approver?.secondaryApprovers);
        const _tertiaryData = createEmailData(data?.approver?.tertiaryApprovers);

        const emailData = [
        ..._primaryData,
        ..._secondaryData,
        ..._tertiaryData
        ];

        try {
        const emailUrl = domain + "/api/Notification/send-email-bulk";

        await axios.post(emailUrl, emailData, {
            headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            },
        });
        
        console.log("send successfully");
        } catch (error) {
        console.error("Error:", error);
        }
    };

  const checkHalfdayClick = (e) => {
    setIsHalfDay(e.target.checked);
    if (e.target.checked) {
      setDays(0.5);
    }
  };

  const [isShowHalfDayButton, setIsShowHalfDayButton] = useState(false);
  useEffect(() => {
        const isSameDay =
            dateFrom &&
            dateTo &&
            new Date(dateFrom).toDateString() === new Date(dateTo).toDateString();

        setIsShowHalfDayButton(isSameDay);

        const _days =
            Math.ceil((new Date(dateTo) - new Date(dateFrom)) / (1000 * 60 * 60 * 24)) + 1;

        if (isSameDay) {
            setDays(1);
            setTemp_days(1);
        } else {
            if (_days > 0) {
            setDays(_days);
            setTemp_days(_days);
            } else {
            setDays(0);
            setTemp_days(0);
            }
        }
    }, [dateTo, dateFrom]);


  const handleWarningProceed = (e) => {
    handleSubmit(e);
    setErrorState(false);
    closeWarningForm();
  };

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TransactionInfo Transaction-Form-Info shadow-xl">
            <div className="transaction-header">
              <div className="sub-title row">
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                  {"Transactions >"}{" "}
                </span>
                <span style={{ borderBottom: "1px solid black" }}>
                  {"Leave"}
                </span>
              </div>
              <div className="transaction-top row">
                <div style={{ width: "70%" }}>
                  <h3>Leave</h3>
                </div>
                <div
                  className="leave-balance-container column"
                  style={{ width: "30%" }}
                >
                  <div className="sick-vacay column">
                    <label>
                      Sick Leave:{" "}
                      {remainingLeaves && remainingLeaves.sickRemaining
                        ? remainingLeaves.sickRemaining
                        : 0}
                    </label>
                    <label>
                      Vacation Leave:{" "}
                      {remainingLeaves && remainingLeaves.vacationRemaining
                        ? remainingLeaves.vacationRemaining
                        : 0}
                    </label>
                    <label>
                      Service Incentive Leave:{" "}
                      {remainingLeaves &&
                      remainingLeaves.serviceIncentiveRemaining
                        ? remainingLeaves.serviceIncentiveRemaining
                        : 0}
                    </label>
                    <label>
                      Solo Parent Leave:{" "}
                      {remainingLeaves && remainingLeaves.soloParentRemaining
                        ? remainingLeaves.soloParentRemaining
                        : 0}
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="transaction-form-upper row"
                style={{
                  justifyContent: "start",
                  padding: "10px 0",
                  display: "none",
                }}
              >
                {CreateButton(
                  "overtime-add-button",
                  "upload row",
                  (e) => setShowUploadForm(true),
                  "UPLOAD",
                  UploadIcon
                )}
                {CreateButton(
                  "overtime-add-button",
                  "viewHistory row",
                  openViewHistoryForm,
                  "VIEW HISTORY",
                  RemoveRedEyeIcon
                )}
              </div>
              <div
                className="transaction-form-upper row"
                style={{ justifyContent: "start", padding: "10px 0" }}
              >
                {CreateButton(
                  "overtime-add-button",
                  "viewHistory row",
                  openViewHistoryForm,
                  "VIEW HISTORY",
                  RemoveRedEyeIcon
                )}
              </div>
            </div>
            <div className="transaction-body">
              <div className="transaction-from-splitItem row">
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Employee</h4>
                    </div>
                    <div className="transaction-form-input">
                      <div
                        className="info-item-holder employee-select row"
                        style={{
                          flexDirection: "row",
                          justifyContent: "normal",
                        }}
                      >
                        <input
                          readOnly
                          className="employeeInput-select"
                          placeholder="Employee"
                          value={employee ? employee : employee}
                        />
                        <button
                          className="select row"
                          onClick={() => setShowEmployeeForm(true)}
                          style={{
                            visibility:
                              userAccess.description === "Admin" ||
                              userAccess.description === "TK" ||
                              userAccess.description === "Time Keeper" ||
                              userAccess.description === "Time Keeper (OT)" ||
                              userAccess.description === "HR Head" ||
                              userAccess.description === "HR Assistant" ||
                              userAccess.description === "HR Assistant2" ||
                              userAccess.description === "HR Assistant3" ||
                              userAccess.description === "HR Manager"
                                ? "visible"
                                : "hidden",
                          }}
                        >
                          <SearchIcon />
                        </button>
                      </div>
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility:
                        !employee && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Leave Type</h4>
                    </div>
                    <div className="transaction-form-input">
                      <LeaveTypeSelect
                        leaveType={leaveTypeId}
                        setLeaveType={setLeaveTypeId}
                      />
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility:
                        !leaveTypeId && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Date From</h4>
                    </div>
                    <div className="transaction-form-input">
                      <DateTimeInput date={dateFrom} setDate={setDateFrom} />
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility:
                        !dateFrom && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Date To</h4>
                    </div>
                    <div className="transaction-form-input">
                      <DateTimeInput date={dateTo} setDate={setDateTo} />
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility: !dateTo && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div className="transaction-from-splitItem row">
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div className="transaction-form-category">
                      <h4>Days</h4>
                    </div>
                    <div className="transaction-form-input info-item">
                      <input
                        type="number"
                        id="days"
                        placeholder="Days"
                        value={days}
                        onChange={(e) => setDays(e.target.value)}
                      />
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility: !days && errorState ? "visible" : "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
                <div className="column" style={{ width: "100%" }}>
                  <div className="transaction-form-item row">
                    <div
                      className="transaction-form-input row"
                      style={{ alignItems: "center" }}
                    >
                      <input
                        type="checkbox"
                        id="leave-allowance"
                        className="checkbox"
                        name=""
                        checked={isHalfDay}
                        disabled={!isShowHalfDayButton}
                        onChange={(e) => checkHalfdayClick(e)}
                      />
                      <h5 style={{ fontWeight: "normal" }}>Half Day?</h5>
                    </div>
                  </div>
                  <span
                    style={{
                      marginTop: "-10px",
                      display: "flex",
                      justifyContent: "center",
                      visibility: "hidden",
                      color: "#ff6565",
                      fontSize: "12px",
                    }}
                  >
                    Please fill up this field
                  </span>
                </div>
              </div>
              <div
                className="transaction-form-item row"
                style={{ paddingTop: "50px", alignItems: "revert" }}
              >
                <div className="transaction-form-category">
                  <h4>Reason</h4>
                </div>
                <div className="transaction-form-input">
                  <textarea
                    id="leave-tamper"
                    style={{
                      width: "95%",
                      minHeight: "100px",
                      borderRadius: "3px",
                      border: "1px solid #80808080",
                      color: "rgb(104, 104, 104)",
                    }}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>
              </div>
              <div
                className="transaction-form-item row"
                style={{ paddingTop: "50px", alignItems: "revert" }}
              >
                <div className="transaction-form-category">
                  <h4>Upload</h4>
                </div>
                <div className="transaction-form-input">
                  <label htmlFor="fileInput" className="browse">
                    Browse...
                  </label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: "none" }}
                  />

                  {files.length > 0 ? (
                    <div
                      style={{ border: "1px solid #97979745", padding: "10px" }}
                    >
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <span key={index}>{file.name}</span>
                        ))}
                      </ul>
                      <div
                        className="buttons row"
                        style={{ display: "flex", justifyContent: "end" }}
                      >
                        <button
                          id="add-family"
                          className="cancel row"
                          onClick={() => clearFiles()}
                          style={{ marginRight: "5px" }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      id="drop-files-here"
                      onDrop={(e) => handleDrop(e)}
                      onDragOver={(e) => handleDragOver(e)}
                      onDragLeave={(e) => handleDragOut(e)}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "5px",
                        padding: "20px",
                        marginTop: "10px",
                        textAlign: "center",
                      }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
              <div className="transaction-form-footer">
                {CreateButton(
                  "leave-add-button",
                  "submit",
                  (e) => submit(e),
                  "SEND REQUEST",
                  ""
                )}
              </div>
              {/* <button onClick={()=>{
                                setShowRequestMessage(true);
                                setIsSuccess(false);
                                const errorMessage = "Fail";
                                setRequestMessage(errorMessage);
                            }
                            }>Test button</button> */}
            </div>
          </div>
        </div>
      </div>
      <UploadForm
        isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        handleFileUpload={handleFileUpload}
      ></UploadForm>
      <ViewHistoryForm
        isOpen={showVieHistoryForm}
        onClose={closeViewHistoryForm}
        user={user}
      ></ViewHistoryForm>
      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeeId}
        setEmployee={setEmployee}
        user={user}
      ></EmployeeSelectForm>
      <WarningForm
        isOpen={showWarning}
        message={`"Date From" to "Date To" is ${temp_days} day/s but you filed ${days} day/s. Please check dates before proceeding.`}
        handleSubmit={handleWarningProceed}
        onClose={closeWarningForm}
      ></WarningForm>
      <GenerateMessage
        form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      ></GenerateMessage>
      {loadingRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
function EmployeeSelectForm({ isOpen, onClose, setEmployeeId, setEmployee, user }) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];
  console.log({user})

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = useCallback(async () => {
    let apiUrl = domain + "/api/Employee/basic-info/all/active";

    if(user?.accessTemplateDescription === "Time Keeper"
      || user?.accessTemplateDescription === "Time Keeper (OT)"
      || user?.accessTemplateDescription === "TK"
    ){
      apiUrl =  domain + `/api/Employee/employee-schedules/timekeeper/${user.employeePersonalInformationId}`;
    }

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      setEmployees(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [user]);
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex, fetchData]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}
function LeaveTypeSelect({ leaveType, setLeaveType }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLeaveType(event.target.value);
  };

  const [leaveTypes, setLeaveTypes] = useState([]);

  const apiUrl = domain + "/api/LeaveType/active";

  const fetchData = useCallback(async () => {
    await axios
      .get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      })
      .then((response) => {
        setLeaveTypes(response.data); // Set the response data to the state
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
    if (leaveType !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [leaveType, fetchData]);

  return (
    <div>
      <select
        id="leave-employee-leaveType"
        value={leaveType}
        onChange={handleSelectChange}
        style={{
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
        }}
      >
        <option value="" disabled hidden>
          Choose a leave type
        </option>
        {leaveTypes.map((leaveType) => SetLeaveTypeList(leaveType))}
      </select>
    </div>
  );
}
function SetLeaveTypeList(leaveType) {
  return (
    <option id={"leaveeAdd" + leaveType.id} value={leaveType.id}>
      {leaveType.description}
    </option>
  );
}
function DateTimeInput({ date, setDate }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleDateTimeChange = (event) => {
    setDate(event.target.value);
    setIsSelected(true);
  };

  useEffect(() => {
    if (date !== undefined && date !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [date]);

  return (
    <div>
      <input
        type="date"
        id={"datetime-"}
        name="datetime"
        value={date} // Exclude milliseconds
        onChange={handleDateTimeChange}
        style={{
          width: "90%",
          height: "30px",
          borderRadius: "3px",
          border: "1px solid #80808080",
          color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
          fontFamily:
            "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
        }}
      />
    </div>
  );
}
function UploadForm({ isOpen, onClose, handleFileUpload }) {
  const handleClose = () => {
    onClose();
    setFiles("");
  };

  const [files, setFiles] = useState([]);

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById("fileInput").value = "";
  };

  const submit = (e) => {
    handleFileUpload(files);
    handleClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            ></div>
            <div>
              <label htmlFor="fileInput" className="browse">
                Browse...
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: "none" }}
              />
              <div
                id="drop-files-here"
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: "2px dashed #ccc",
                  borderRadius: "5px",
                  padding: "20px",
                  marginTop: "10px",
                  textAlign: "center",
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div
                    className="buttons row"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <button
                      id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px" }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <div
                className="buttons row"
                style={{
                  justifyContent: "center",
                  padding: "40px 40px 20px 40px",
                }}
              >
                <button
                  id="add-family"
                  className="save row"
                  onClick={(e) => submit(e)}
                  style={{ marginRight: "5px" }}
                >
                  UPLOAD
                </button>
                <button
                  id="add-family"
                  className="cancel row"
                  onClick={() => handleClose()}
                >
                  CANCEL
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
function ViewHistoryForm({ isOpen, onClose, user }) {
  var header = [
    "Reference No.",
    "Date From",
    "Date To",
    "Leave Type",
    "Days",
    "Is Half Day",
    "Reason",
    "Reason For Rejection",
    "Date Requested",
    "Uploaded Image",
    "Status",
  ];
  var accessor = [
    "referenceNumber",
    "dateFrom",
    "dateTo",
    "leaveTypeDescription",
    "days",
    "isHalfDay",
    "reason",
    "reasonForRejection",
    "dateRequested",
    "content",
    "status",
  ];

  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState(false);

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/LeaveRequest";

    try {
      setLoading(true);
      const response = await axios.get(
        `${apiUrl}/employee/${user.employeePersonalInformationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can include other headers if needed
          },
        }
      );

      setRequests(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [user]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [fetchData, isOpen]);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Leave Filed History</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div
                className="users-table container"
                style={{ overflow: "unset" }}
              >
                <CreateTable
                  dataList={requests ? requests : []}
                  dataHeader={header}
                  dataAccessor={accessor}
                />
                {requests.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            ></div>
          </div>
        )}
      </div>
    </>
  );
}
export function CreateTable({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  deleteHandleClick,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfo(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Reference No.") {
    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Uploaded Image") {
    if (data.content) {
      const imageSrc = "data:image/jpeg;base64," + data.content;

      return (
        <td>
          <img
            className=""
            src={imageSrc}
            alt=""
            style={{ width: "250px", height: "auto" }}
          />
        </td>
      );
    }
    return (
      <td>
        <img className="" src="" alt="" />
      </td>
    );
  }

  if (header === "Approved?") {
    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.isApproved}
          disabled={true}
        />
      </td>
    );
  }

  if (
    header === "Has Allowance" ||
    header === "Is Above 2 Hours" ||
    header === "Is Half Day"
  ) {
    return <td>{value.toString()}</td>;
  }

  if (
    header === "Time From" ||
    header === "Time To" ||
    header === "Time In" ||
    header === "Time Out"
  ) {
    const time = _cell.render("Cell").props.value;
    if (!time) {
      return <td>-</td>;
    }

    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Request Date" ||
    header === "Date Requested"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  //Double type data
  if (
    header === "Over Percentage" ||
    header === "Deduction" ||
    header === "Salary" ||
    header === "Employee" ||
    header === "Employer" ||
    header === "Range From" ||
    header === "Range To" ||
    header === "Monthly Salary" ||
    header === "SSS ER" ||
    header === "SSS EE" ||
    header === "SSS Total" ||
    header === "ECER" ||
    header === "Total Contribution ER" ||
    header === "Total Contribution EE" ||
    header === "Total Contribution Total" ||
    header === "SE Total Contribution" ||
    header === "Salary Range From" ||
    header === "Salary Range To" ||
    header === "Total Monthly Premium" ||
    header === "Percentage" ||
    header === "Amount" ||
    header === "Total Loan" ||
    header === "Total Balance" ||
    header === "Default Deduction" ||
    header === "Allowance" ||
    header === "Daily Salary" ||
    header === "Allowance" ||
    header === "Total Basic" ||
    header === "Rate" ||
    header === "Hours OT Regular" ||
    header === "Total OT Regular" ||
    header === "Hours OT Exceeded" ||
    header === "Total OT Exceeded" ||
    header === "Hours OT Restday" ||
    header === "Total OT Restday" ||
    header === "Hours Holiday Special" ||
    header === "Total Holiday Special" ||
    header === "Hours Holiday Regular" ||
    header === "Total Holiday Regular" ||
    header === "Hours Restday Holiday Special" ||
    header === "Total Restday Holiday Special" ||
    header === "Hours Restday Holiday Regular" ||
    header === "Total Restday Holiday Regular" ||
    header === "Additions" ||
    header === "SSS" ||
    header === "Pagibig" ||
    header === "Philhealth" ||
    header === "SSS Loan" ||
    header === "SSS Calamity Loan" ||
    header === "Pagibig Loan" ||
    header === "Pagibig Calamity Loan" ||
    header === "Tax" ||
    header === "Deductions" ||
    header === "Adjustments" ||
    header === "Total Net Pay" ||
    header === "Days Absent" ||
    header === "Absent/s" ||
    header === "Days Leave" ||
    header === "Leave/s" ||
    header === "Hours Exceeded" ||
    header === "Total Exceeded" ||
    header === "Hours Undertime" ||
    header === "Undertime" ||
    header === "Hours Late" ||
    header === "Late" ||
    header === "Night Diff" ||
    header === "OT Regular" ||
    header === "OT Restday" ||
    header === "Holiday Special" ||
    header === "Holiday Regular" ||
    header === "Restday Holiday Special" ||
    header === "Restday Holiday Regular" ||
    header === "Total Absents" ||
    header === "Total Late" ||
    header === "Total Undertime" ||
    header === "Total Leaves" ||
    header === "Total Night Diff" ||
    header === "Total Exceed" ||
    header === "Exceed" ||
    header === "Hours" ||
    header === "Days"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: "relative", display: "inline-block", zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "-50%",
            transform: "translateX(-50%)",
            backgroundColor: "white",
            color: "gray",
            padding: "5px",
            borderRadius: "5px",
            pointerEvents: "none",
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};
function WarningForm({ isOpen, message, onClose, handleSubmit }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Warning!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div
              className="popUp-body"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>{message}</span>
            </div>
            <div
              className="buttons row"
              style={{
                justifyContent: "center",
                padding: "40px 40px 20px 40px",
              }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleSubmit}
                style={{ marginRight: "5px" }}
              >
                PROCEED
              </button>
              <button
                id="add-family"
                className="cancel row"
                onClick={() => handleClose()}
              >
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default Leave;
